<div *ngFor="let pair of getObjectPairs(json)">
    <span class="text-secondary fw-semibold">{{ pair.key }}: </span>
    <span *ngIf="isObject(pair.value)">
        <div class="ms-5">
            <avs-json-data-viewer [json]="pair.value"></avs-json-data-viewer>
        </div>
      </span>
    <span *ngIf="!isObject(pair.value)" class="text-danger">{{ pair.value }}</span>
</div>
